import React from 'react';
import SafeIcon from '../../common/SafeIcon';

export default function StatCard({ title, value, trend, trendUp, icon }) {
  return (
    <div className="glass-panel rounded-xl p-5 relative overflow-hidden group">
      <div className="absolute top-0 right-0 w-32 h-32 bg-invoice-green/5 rounded-full blur-3xl -mr-10 -mt-10 transition-all group-hover:bg-invoice-green/10"></div>
      
      <div className="flex justify-between items-start mb-4 relative z-10">
        <h3 className="text-cream-muted text-sm font-medium tracking-wide">{title}</h3>
        <div className="p-2 bg-charcoal-light rounded-lg text-cream-muted">
          <SafeIcon icon={icon} className="w-4 h-4" />
        </div>
      </div>
      
      <div className="relative z-10">
        <div className="text-3xl font-light text-cream font-mono mb-2">{value}</div>
        <div className={`text-xs font-medium flex items-center gap-1 ${trendUp ? 'text-invoice-green' : 'text-red-400'}`}>
          <SafeIcon name={trendUp ? 'TrendingUp' : 'TrendingDown'} className="w-3 h-3" />
          {trend} from last month
        </div>
      </div>
    </div>
  );
}